import { RM3_RIBBON_COLORS } from 'arbitrip-common/client/utils/HotelDealsRm3';

// Spec §7: the ribbon palette is fixed for every brand and reaches the SCSS as custom properties on each RM3 root
// (the page section and the room-details modal, which renders in a portal outside it).
const RIBBON_CSS_VARIABLES = Object.freeze(
    Object.fromEntries(
        Object.entries(RM3_RIBBON_COLORS).map(([name, value]) => [
            `--rm3-ribbon-${name.toLowerCase().replace(/_/g, '-')}`,
            value,
        ]),
    ),
);

export default RIBBON_CSS_VARIABLES;
